import { Badge } from "@/components/ui/badge";
import { calculateTripStatus } from "@/lib/trip-status";
import { cn } from "@/lib/utils";

export function TripStatusBadge({
  startDate,
  endDate,
  className,
  showLabel = false,
}: {
  startDate: string;
  endDate: string;
  className?: string;
  showLabel?: boolean;
}) {
  const status = calculateTripStatus(startDate, endDate);

  return (
    <div className="inline-flex items-center gap-1.5">
      <Badge
        variant={status.variant}
        className={cn("px-2 py-0.5 text-xs transition-colors shrink-0", status.className, className)}
        title={status.label}
      >
        {status.badgeText}
      </Badge>
      {showLabel && (
        <span className="text-xs text-muted-foreground hidden sm:inline">
          {status.label}
        </span>
      )}
    </div>
  );
}
